// @flow

import React, { type Node } from 'react';
import { RenderButtonArea, RenderPaymentInstructions, RenderTotalDueDateAndBarCode } from './pagofacil-components';
import { EmailVoucherMessage } from '../commons/email-voucher-message';

export function PagofacilPage(): Node {
  return (
    <>
      <EmailVoucherMessage
        headerMessage="Orden de pago generada!"
        textBeforeEmailAddress="Una copia de su orden de pago fue enviada a"
        textAfterEmailAddress=", sin embargo, ya puedes pagar tu compra presentando los siguientes datos:"
      />
      <RenderTotalDueDateAndBarCode />
      <br />
      <RenderButtonArea />
      <RenderPaymentInstructions />
      <br />
    </>
  );
}
